module.exports = __webpack_public_path__ + "static/media/full-band-hero.a5f7a612.jpg";